module.exports = __webpack_public_path__ + "static/img_slideshow_01-6c14aa2ae51c4b331c37317dda5a8fb0.jpg";